import { useQuery } from '@tanstack/react-query';
import { publicQuotesApi } from '@/services/public-quotes';

export const usePublicQuote = (token: string | undefined) =>
  useQuery({
    queryKey: ['public-quote', token],
    queryFn: () => publicQuotesApi.get(token!),
    enabled: !!token,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });
